if (!customElements.get('ly-track-order')) {
    class LyTrackOrder extends HTMLElement {

        URLS = ['https://homedelivery.cevalogistics.com/Track?trackingID=', 'https://delivers.maersk.com/track/#/detail?pro=']

        connectedCallback() {
            this.form = this.querySelector('form')
            this.input = this.form.querySelector('input')
            this.body = this.querySelector('.ly-track-order-body')

            this.form.addEventListener('submit', this.submit)
        }

        get inputValue() {
            return this.input.value.trim()
        }

        get activeUrlIndex() {
            if (!this.inputValue) return -1
            if (/[a-zA-Z]/.test(this.inputValue)) return 0
            return 1
        }

        get activeUrl() {
            return this.URLS[this.activeUrlIndex] + this.inputValue
        }

        submit = evt => {
            evt.preventDefault()
            if (!this.inputValue) {
                this.input.classList.add('is-invalid')
                return
            }
            this.input.classList.remove('is-invalid')

            window.open(
                this.activeUrl,
                'trackWindow',
                'width=1000,height=700,resizable=yes,scrollbars=yes'
            )
        }

    }

    customElements.define('ly-track-order', LyTrackOrder)
}